/*
 * Mobile collection grid density toggle (staff WP6): 2-up default, 1-up option,
 * persisted per browser. The choice lives as an attribute on <html> feeding the
 * --rbc-cols-mobile CSS var, so the provider's AJAX filter re-render (which
 * replaces the grid's whole DOM block) can't wash it off. An inline script in
 * s_collection.liquid pre-sets the attribute before first paint.
 */
(function () {
  var KEY = 'rbcCollectionCols';
  var root = document.documentElement;

  function buttons() {
    return document.querySelectorAll('[data-rbc-grid-toggle] button');
  }

  function apply(cols) {
    if (cols === '1') root.setAttribute('data-rbc-cols-1', '');
    else root.removeAttribute('data-rbc-cols-1');
    buttons().forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-cols') === cols));
    });
    patchSizes();
  }

  /* Card images carry `sizes` computed server-side for the 2-up layout
     (…calc(90vw/2)…). At 1-up the browser would keep picking srcset candidates
     half the displayed width — soft boots on a page that sells on photography.
     Rewriting sizes makes it re-pick; going back to 2-up restores the original
     (browsers never downgrade an already-loaded image, so no re-fetch cost). */
  function patchSizes() {
    var oneUp = root.hasAttribute('data-rbc-cols-1');
    document.querySelectorAll('.\\#collection-grid img[sizes]').forEach(function (img) {
      var orig = img.getAttribute('data-rbc-sizes') || img.getAttribute('sizes');
      if (orig.indexOf('90vw/2') === -1) return;
      img.setAttribute('data-rbc-sizes', orig);
      img.setAttribute('sizes', oneUp ? orig.split('90vw/2').join('90vw') : orig);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rbc-grid-toggle] button');
    if (!btn) return;
    var cols = btn.getAttribute('data-cols');
    try { localStorage.setItem(KEY, cols); } catch (err) {}
    apply(cols);
  });

  // Filter/sort re-renders rebuild the grid with server-rendered 2-up sizes —
  // re-patch when the provider swaps its dynamic block.
  var provider = document.querySelector('collection-provider');
  if (provider) {
    new MutationObserver(function () { patchSizes(); })
      .observe(provider, { childList: true, subtree: true });
  }

  var saved = '2';
  try { saved = localStorage.getItem(KEY) || '2'; } catch (err) {}
  apply(saved);
})();
